import AppSection from '../../../../component/layout/AppSection'
import { useEffect, useState } from 'react'

import CenterService from '../../../../services/centers/center.service.js'
import CenterTypeLinks from '../nav/CenterTypeLinks'
import CenterNavLinks from '../nav/CenterNavLinks'
import { useParams } from 'react-router-dom'

interface CommonProps
  extends React.ComponentPropsWithoutRef<typeof AppSection> {
  title?: string
  dataFacade?: any
  toolbar?: React.ReactNode
  children?: React.ReactNode
}

const CenterSection = ({
  title,
  dataFacade,
  toolbar,
  ...otherProps
}: CommonProps) => {
  const [currentCenter, setCurrentCenter] = useState()

  const { id } = useParams()

  useEffect(() => {
    getCenterData()
  }, [])

  const getCenterData = async () => {
    if (id && id !== 'undefined') {
      const response = await CenterService.getById(id)
      if (response) {
        setCurrentCenter(response.resp)
      }
    }
  }

  return (
    <AppSection
      {...otherProps}
      title={currentCenter?.basicData?.name || title}
      dataFacade={dataFacade}
      header={<CenterTypeLinks blur={id ? true : undefined} />}
      subheader={
        id ? (
          <CenterNavLinks id={id} centerType={currentCenter?.centerType} />
        ) : undefined
      }
      toolbar={toolbar}
      // toolbar={toolbar ||
      //   <Group w="100%" h={50} justify='space-between' align='center'>
      //     <Group fw="bold" fz="110%" c="moure-blue">{currentCenter?.basicData?.name}</Group>
      //     <Group justify="flex-end"></Group>
      //     <Group justify="flex-end">
      //       <AppButton preset="back" />
      //       <AppButton preset="cancel" />
      //       <AppButton preset="remove" />
      //       <AppButton preset="save" />
      //     </Group>
      //   </Group>
      // }
      // headerOptions={headerOptions}
    >
      {/* {data} */}
    </AppSection>
  )
}

export default CenterSection
